/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Hide_PasswordInputs */

const en_field_hide_password = /** @type {(inputs: Field_Hide_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide password`)
};

const de_field_hide_password = /** @type {(inputs: Field_Hide_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort verbergen`)
};

/**
* | output |
* | --- |
* | "Hide password" |
*
* @param {Field_Hide_PasswordInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const field_hide_password = /** @type {((inputs?: Field_Hide_PasswordInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Hide_PasswordInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_field_hide_password(inputs)
	return en_field_hide_password(inputs)
});